import { ContextService } from '../../../../../services/context_service';
import { DialogStromVerbrauch } from '../../../dialogs/DialogStromVerbrauch';
import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { IDs } from '../../../../../helpers/IDs';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../../core/elements/WActionButton';

export interface StromButtonWrapperProps {
    data: any;
    values: any;
    jahr: number;
    standortSelected: any;
    disabled?: boolean;
    callback: (data: any) => void;
}

export interface StromButtonWrapperState {
    dataForOptionalDialog: any;
}

export class StromButtonWrapper extends React.Component<StromButtonWrapperProps, StromButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataForOptionalDialog: undefined,
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private buttonOnAction: any;

    componentWillUnmount(): void {
        if (this.buttonOnAction) {
            this.triggerService.unregister('onAction', 'StromButtonWrapper', this.buttonOnAction);
        }
    }

    render(): JSX.Element {
        const { dataForOptionalDialog } = this.state;
        const { standortSelected, jahr, values, disabled } = this.props;

        if (!values) {
            return <span></span>;
        }

        const onClose = () => {
            this.setState({ dataForOptionalDialog: undefined });
        };

        let title: string;
        if (this.state.dataForOptionalDialog) {
            const zaehlerTid = (values || {}).zaehler_tid_orig;
            const zaehlernummer = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_STROM}_bundle`] || {}).zaehler_tid || [])
                .find((item: any) => item.tid === zaehlerTid) || {}).zaehlernummer || '';
            title = `${jahr}\u00A0\u00A0\u00A0\u00A0\u00A0${standortSelected.name}\u00A0\u00A0\u00A0\u00A0\u00A0${zaehlernummer}`;
        }

        return (
            <div style={{ marginTop: -10, marginBottom: 20 }}>
                <WActionButton
                    styleProps={{ ...(disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {}) }}
                    label='Monatsverbräuche'
                    insideText='Monatsverbräuche'
                    tooltip='Monatsverbräuche bearbeiten'
                    key='monatsverbraeuche'
                    action='calculator'
                    disabled={disabled}
                    onAction={() => {
                        if (disabled) {
                            // alert('Bitte wählen Sie zunächst Monatsrechnungen aus.');
                        } else {
                            const dataForDialog = {
                                standortSelected,
                                entity: { entity: IDs.ENT_ENERGIEDATEN_STROM },
                                jahr,
                                values
                            };
                            if (JSON.stringify(dataForOptionalDialog) !== JSON.stringify(dataForDialog)) {
                                this.setState({ dataForOptionalDialog: dataForDialog });
                            }
                        }
                    }}
                    ref={(button: any) => {
                        if (button && !this.buttonOnAction) {
                            // Siehe auch onFormChangeStromAutoOpenDialog
                            this.buttonOnAction = button.props.onAction;
                            this.triggerService.register('onAction', 'StromButtonWrapper', this.buttonOnAction);
                        }
                    }}
                />
                {this.state.dataForOptionalDialog &&
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={onClose}
                    >
                        <DialogStromVerbrauch
                            data={this.props.data}
                            standortSelected={dataForOptionalDialog.standortSelected}
                            jahr={dataForOptionalDialog.jahr}
                            values={dataForOptionalDialog.values}
                            onChange={(entityName: string, formValues: any) => {
                                onClose();
                                const vals = dataForOptionalDialog.values;
                                vals.abrechnungszeitraum_von = formValues.abrechnungszeitraum_von;
                                vals.abrechnungszeitraum_bis = formValues.abrechnungszeitraum_bis;
                                vals.verbrauch_kwh = formValues.verbrauch_kwh;
                                vals.kosten_netto = formValues.kosten_netto;
                                vals.co2_emissionen = formValues.co2_emissionen;
                                vals.spitzenlast = formValues.spitzenlast;
                                this.props.callback(vals);
                                this.triggerService.fire('reload', entityName);
                            }}
                            onClose={onClose}
                        />
                    </DialogWrapper2>
                }
            </div>
        );
    }
}
